<template>
  <div class="tx-app-container" v-cloak>
    <div class="tx-app-container" v-if="is_mobile">
      <Toast />
      <div id="tx-toast-container"></div>
      <Main />
    </div>
    <div v-else>
      <div class="code-wraper f-center">
        <div class="tx-border f-center">
          <QrcodeVue :size="300" :value="computedHref" />
        </div>
        <div class="code-tips f-center">
          <span class="buy-tips">请少侠使用微信</span>
          <span class="buy-tips">扫描二维码参与活动</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import sns_oauth from '@/lib/tx-sns-auth/sns_oauth';
import 'whatwg-fetch';
import QrcodeVue from 'qrcode.vue';
import { inject, onMounted, reactive } from 'vue';
// import lazyLoad from './components/lazyLoad.vue';
import usePerformanceMetrics from './plugins/vue/usePerformance';
usePerformanceMetrics();
// 检测资源
import { generateFingerprint } from './utils/generateFingerprint';
import eventEmitter from '@utils/event';
import Toast from './components/toast.vue';
import useWeChatEnv from './plugins/vue/useWeChatOrMiniProgram';
import getQueryParams from './utils/getQueryParams';
import stringToBool from './utils/stringToBool';
import { get_team_share_data, bind_magic } from './utils/api';
import Main from './pages/main.vue';
import getRandomUrl from './utils/getRandomUrl';
const {
  set_token,
  set_utm_source,
  set_extra,
  set_share_id,
  invite_id,
  set_invite_id,
  set_channel,
  share_id,
  is_mobile,
} = inject('GlobalStore');
const { set_team_share_data, set_together_id, set_item_id } = inject('GlobalData');
const isProd = import.meta.env.VITE_ENV;
const computedHref = computed(() => {
  return window.location.href;
});

const { isWeChat, isMiniProgram } = useWeChatEnv();
const current_page = ref('main');
// 简单实现一个路由

const state = reactive({
  is_show_account: true,
});

onMounted(async () => {
  window.logout = sns_oauth.sns.snsLogout;
  let token = getQueryParams()['token'];
  if (token) {
    set_token(token);
  }

  // snsAuthLogin();

  let utm_source = getQueryParams()['utm_source'];
  if (utm_source && stringToBool(utm_source)) {
    set_utm_source(utm_source);
  }

  let extra = getQueryParams()['extra'];
  if (extra && stringToBool(extra)) {
    set_extra(extra);
  }
  window.figureCode = generateFingerprint();
  let inviteId = getQueryParams()['invite_id'];
  if (inviteId) {
    set_invite_id(inviteId);
  }

  let shareId = getQueryParams()['share_id'] || inviteId;
  if (shareId) {
    set_share_id(shareId);
  }

  let together_id = getQueryParams()['together_id'];
  if (together_id) {
    set_together_id(together_id);
  }

  let item_id = getQueryParams()['item_id'];
  if (item_id) {
    set_item_id(item_id)
  }

  // debug代码
  // setTimeout(()=>{
  //   set_together_id('68e9fd7abf7b59be0e4af904')
  // },2000)

  if (isWeChat.value) {
    set_channel('wx');
  } else if (isMiniProgram.value) {
    set_channel('xcx');
  }
  const isMofang = getQueryParams()['isMofang'];
  if (!!isMofang) {
    mofangAuth()
  } else {
    snsAuthLogin();
  }


  eventEmitter.on('go', (value) => {
    current_page.value = value;
  });

  // 积木服务授权
  eventEmitter.on('mofangAuthBus', () => {
    mofangAuth()
  });

  // 大神相关
  ds.ready().then(() => {
    if (ds.isGodlike) {
      set_channel('ds');
    }
  });

  eventEmitter.on('account', (value) => {
    state.is_show_account = value;
  });

  eventEmitter.on('main', () => {
    current_page.value = 'main';
    setTimeout(() => {
      eventEmitter.emit('login');
    }, 1000);
  });
});

/**
 * 微信授权
 */
function snsAuthLogin(callback) {
  if (isWeChat.value || isMiniProgram.value) {
    sns_oauth.sns.getSnsUserInfo().then((res) => {
      if (res.code !== 1) {
        // 未授权
        sns_oauth.sns.checkLogin(() => {
          console.log('授权成功-加载数据');
          getShareTeamInfo(callback)
        });
        return;
      }
      console.log('已经授权过-加载数据');
      getShareTeamInfo(callback)
    });
  } else {
    console.log('不需要微信授权，直接加载数据');
    getShareTeamInfo(callback)
  }
}

/**
 * 获取分享者的队伍信息
 */
function getShareTeamInfo(callback) {
  if (!invite_id.value) {
    eventEmitter.emit('init', callback);
    return
  }
  get_team_share_data(invite_id.value).then((res) => {
    if (res.code !== 1) {
      eventEmitter.emit('toast', {
        text: res.errorMsg,
      });
      set_invite_id('');
      eventEmitter.emit('init', callback);
      return
    }
    set_team_share_data(res.data)
    eventEmitter.emit('init', callback);
  })
}

/**
 * 积木授权
 */
function mofangAuth() {
  window.authLogin.def = 'txMofang'
  if (!window.authLogin.check('game')) {
    window.authLogin.go()
  } else {
    const myurl = window.authLogin.urlps(location.href)
    const status = myurl.data('status')
    const code = myurl.data('code')
    console.log('积木授权成功======', { code, status });
    if (Number(status) === 200) {
      bindMagic(code)
    } else {
      eventEmitter.emit('toast', {
        text: '服务授权失败',
        duration: 2,
      });
      snsAuthLogin()
    }
  }
}

function bindMagic(code) {
  bind_magic({
    auth_code: code
  }).then(res => {
    if (res.code === 1) {
      eventEmitter.emit('toast', {
        text: '授权成功',
        duration: 2,
      });
      snsAuthLogin(() => {
        eventEmitter.emit('showHongbaoModal', 'showMoney');
      })
    } else {
      eventEmitter.emit('toast', {
        text: res.errorMsg,
        duration: 2,
      });
      snsAuthLogin(() => {
        eventEmitter.emit('showHongbaoModal', 'close');
      })
    }
  })
}
</script>

<style lang="scss">
.tx-app-container {
  // @include bg('centre_round_1');
  overflow: hidden;
}

.empty {
  height: 0px;
  width: 100%;
}

.code-wraper {
  width: 100vw;
  height: 100vh;
  background-color: #242424;
  color: white;
  flex-direction: column;
}

.tx-border {
  width: 315px;
  height: 315px;
  background-color: white;
}

.code-tips {
  flex-direction: column;
  margin-top: 20px;
  font-size: 20px;
}
</style>
